import { formatISO } from "date-fns/esm";
import partialRight from "lodash/fp/partialRight";

export const formatISODate = partialRight(formatISO, [{ representation: "date" }]);
